import { NgModule } from "@angular/core";
import { CommonModule as NgCommonModule } from "@angular/common";
import {RouterModule, Routes} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';
import {AuthGuardService as AuthGuard} from "../../services/auth-guard";

import { TrackingComponent } from "./tracking-component.component";
import { TrackingDetailsComponent } from "./tracking-details/tracking-details.component";
import { LoadingScreenComponent } from "src/app/common/components/loading-screen/loading-screen.component";
import { CommonModule } from "src/app/common/common.module";

const routes: Routes = [
    { path: "tracking", component: TrackingComponent, canActivate: [AuthGuard] },
    { path: "tracking/:trackId", component: TrackingDetailsComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [
        RouterModule,
        FormsModule,
        NgCommonModule,
        RouterModule.forChild(routes),
        CommonModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [
        TrackingComponent, // main page of tracking
        TrackingDetailsComponent,
    ],
    exports: [
      TranslateModule
    ],
})
export class TrackingModule {}
